import * as React from "react";
import { connect } from "react-redux";
import StockRequirementsRect from "./StockRequirementsRect";
import { ReduxFilters } from "../reducers/BusinessLogic";
import { getStockRequirementStartDate } from "../reducers/properties";
import { getDateOfISOWeekShift } from "../../../../lib/Util";
import type { ReduxState } from "../reducers/reducers";

type OwnProps = {};
type Props = OwnProps & ReduxProps;

class StockRequirementsGanttChartContent extends React.Component<Props> {
    renderStockRequirements() {
        const current_shift = this.props.properties.current_shift;
        const week = this.props.properties.week;
        const year = this.props.properties.year;

        if (!week || !year) {
            return null;
        }

        const start_date_ts = getDateOfISOWeekShift(current_shift, week, year);
        const stock_requirements_arr: React.ReactNode[] = [];

        const insights_map = this.props.insights_map_stock_requirements;
        const resolution_map = new Map<number, number>();
        const stock_requirements = ReduxFilters.filterStockRequirements(
            this.props.lines_orders,
            this.props.unscheduled_orders,
            this.props.stock_requirements,
            this.props.orders_filters,
            this.props.stock_requirements_filters,
            this.props.insights_map_stock_requirements ?? new Map()
        );

        // if the same material exists in the past then we don't show it
        for (const sr of stock_requirements) {
            const start_date = getStockRequirementStartDate(sr.shift_start_time, start_date_ts.getTime());

            let line_index = 0;
            if (resolution_map.has(start_date)) {
                line_index = (resolution_map.get(start_date) || 0) + 1;
            }

            resolution_map.set(start_date, line_index);

            stock_requirements_arr.push(
                <StockRequirementsRect
                    key={sr.uuid}
                    line_index={line_index}
                    stock_requirement={sr}
                    uuid={sr.uuid}
                    has_insight={insights_map?.has(sr.uuid) ?? false}
                    is_ctrl_down={this.props.is_ctrl_down}
                    properties={this.props.properties}
                />
            );
        }
        return stock_requirements_arr;
    }

    renderContent = () => {
        return (
            <>
                <linearGradient id="stock-requirements-gradient" x1="0" x2="1" y1="0" y2="0">
                    <stop offset="0%" stopColor="#A2E6CD" />
                    <stop offset="90%" stopColor="#CEF5E6" />
                    <stop offset="100%" stopColor="#E6F5EF" />
                </linearGradient>
                <linearGradient id="stock-requirements-gradient-insight" x1="0" x2="1" y1="0" y2="0">
                    <stop offset="0%" stopColor="#f78782" />
                    <stop offset="90%" stopColor="#fae4e3" />
                    <stop offset="100%" stopColor="#faf3f2" />
                </linearGradient>
                {this.renderStockRequirements()}
            </>
        );
    };

    render() {
        return this.renderContent();
    }
}

const mapState = (state: ReduxState) => {
    const stock_requirements = state.gantt_chart_stock_requirements.stock_requirements;
    const planning_table = state.gantt_chart_planning_table;
    const orders_filters = state.gantt_chart_filters;
    const lines_orders = state.gantt_chart_lines_orders.lines_orders;
    const unscheduled_orders = state.gantt_chart_lines_orders.unscheduled_orders;
    const stock_requirements_filters = state.gantt_chart_stock_requirements_filter;
    const insights_map_stock_requirements = state.gantt_chart_insights.insights_map_stock_requirements;

    return {
        lines_orders,
        unscheduled_orders,
        orders_filters,
        stock_requirements_filters,
        properties: state.gantt_chart_properties,
        is_ctrl_down: planning_table.is_ctrl_down,
        stock_requirements,
        insights: state.gantt_chart_insights.insights,
        insights_map_stock_requirements,
    };
};

type ReduxProps = ReturnType<typeof mapState>;

export default connect<ReturnType<typeof mapState>, {}, OwnProps, ReduxState>(mapState)(
    StockRequirementsGanttChartContent
);
